import { Listing } from "./types";

// 本地写死的信息数据（23 条：二手转让 16 / 房屋租赁 3 / 车辆买卖 2 / 生活服务 2）
// 结构对齐参考站；主体名称与联系人均为虚构文案
export const listings: Listing[] = [
  {
    id: 1,
    title: "iPhone 手机低价售卖 性能卓越 品质保障",
    summary: "多款 iPhone 手机低价出售，成色好，无维修史，当面验货。",
    category: "second-hand",
    subCategory: "phone",
    price: "1500元",
    publisherName: "周正阳",
    publisherType: "merchant",
    companyName: "通讯优选数码商行",
    publishedAt: "2026-09-12",
    views: 4063,
    top: true,
    contactPhone: "138****0001",
    content: [
      "多款 iPhone 手机低价出售，成色好，无维修史，支持当面验机。",
      "机型涵盖主流容量版本，电池健康度与外观成色均可现场查看。",
    ],
  },
  {
    id: 2,
    title: "本人闲置一台戴尔 i5 笔记本要转，99 新",
    summary: "戴尔 i5 笔记本，8G 内存，256G 固态，办公学习利器。",
    category: "second-hand",
    subCategory: "computer",
    price: "2000元",
    publisherName: "何晓琳",
    publisherType: "personal",
    publishedAt: "2026-09-07",
    views: 1465,
    top: true,
    contactPhone: "138****0002",
    content: [
      "自用戴尔 i5 笔记本，8G 内存 + 256G 固态，日常办公与网课流畅。",
      "外观 99 新，无磕碰，原装电源适配器齐全，可当面验机。",
    ],
  },
  {
    id: 3,
    title: "二手中央空调市场 货源充足 放心省心",
    summary: "各类品牌二手中央空调，包安装，质保一年，量大从优。",
    category: "second-hand",
    subCategory: "appliance",
    price: "面议",
    publisherName: "徐立成",
    publisherType: "merchant",
    companyName: "恒通电器经营部",
    publishedAt: "2026-09-05",
    views: 1251,
    top: true,
    contactPhone: "138****0003",
    content: [
      "各类品牌二手中央空调现货充足，支持现场试机。",
      "提供包安装服务，质保一年，批量采购可议价。",
    ],
  },
  {
    id: 4,
    title: "小米 5 高配版 手机",
    summary: "出售自用小米 5 高配版，九五新，配件齐全，原装充电器数据线。",
    category: "second-hand",
    subCategory: "phone",
    price: "面议",
    publisherName: "吴静怡",
    publisherType: "personal",
    publishedAt: "2026-09-11",
    views: 5201,
    recommend: true,
    contactPhone: "138****0004",
    content: [
      "自用小米 5 高配版，九五新，功能一切正常。",
      "配件齐全，含原装充电器与数据线，支持当面交易。",
    ],
  },
  {
    id: 5,
    title: "联想小新 Pro16 轻薄本",
    summary: "R7/16G/512G，2.5K 屏，使用半年，成色如新，箱说全。",
    category: "second-hand",
    subCategory: "computer",
    price: "3999元",
    publisherName: "郑海涛",
    publisherType: "personal",
    publishedAt: "2026-09-09",
    views: 6088,
    recommend: true,
    contactPhone: "138****0005",
    content: [
      "联想小新 Pro16，R7 处理器 / 16G 内存 / 512G 固态，2.5K 高色域屏。",
      "使用约半年，成色如新，包装与说明书齐全。",
    ],
  },
  {
    id: 6,
    title: "二手双开门冰箱 对开门",
    summary: "双开门大冰箱，容量大，制冷好，成色佳，搬家急出，可验货。",
    category: "second-hand",
    subCategory: "appliance",
    price: "1199元",
    publisherName: "孙丽君",
    publisherType: "personal",
    publishedAt: "2026-09-06",
    views: 1548,
    recommend: true,
    contactPhone: "138****0006",
    content: [
      "双开门冰箱，容量大、制冷正常，外观成色良好。",
      "因搬家急出，价格可小幅商议，支持上门验货。",
    ],
  },
  {
    id: 7,
    title: "惠普暗影精灵 6 游戏本",
    summary: "i7-10750H/16G/512G/GTX1650Ti，网游流畅，成色好，原装充电器。",
    category: "second-hand",
    subCategory: "computer",
    price: "3999元",
    publisherName: "朱明亮",
    publisherType: "personal",
    publishedAt: "2026-09-06",
    views: 7947,
    recommend: true,
    contactPhone: "138****0007",
    content: [
      "惠普暗影精灵 6，i7-10750H / 16G / 512G / GTX1650Ti。",
      "主流网游流畅运行，成色好，附原装充电器。",
    ],
  },
  {
    id: 8,
    title: "二手 iPhone14 256G 国行无修",
    summary: "国行 iPhone14 256G，电池健康 95%，无维修无拆机，支持当面验机。",
    category: "second-hand",
    subCategory: "phone",
    price: "4199元",
    publisherName: "胡文静",
    publisherType: "personal",
    publishedAt: "2026-09-05",
    views: 4407,
    recommend: true,
    contactPhone: "138****0008",
    content: [
      "国行 iPhone14 256G，电池健康度 95%。",
      "无维修、无拆机记录，原装配件，支持当面验机。",
    ],
  },
  {
    id: 9,
    title: "二手空调 挂机柜机出租出售",
    summary: "各品牌二手空调挂机柜机，出租出售，可安装，先报价后维修。",
    category: "second-hand",
    subCategory: "appliance",
    price: "面议",
    publisherName: "林浩然",
    publisherType: "merchant",
    companyName: "汇通电子电器商行",
    publishedAt: "2026-09-05",
    views: 6329,
    recommend: true,
    contactPhone: "138****0009",
    content: [
      "各品牌二手空调挂机、柜机，支持出租与出售两种方式。",
      "提供上门安装，先报价后维修，价格透明。",
    ],
  },
  {
    id: 10,
    title: "三星 S23 二手 全网通",
    summary: "三星 Galaxy S23 8+256，成色 9 新，屏幕无划痕，功能正常。",
    category: "second-hand",
    subCategory: "phone",
    price: "2699元",
    publisherName: "罗雨欣",
    publisherType: "personal",
    publishedAt: "2026-09-14",
    views: 2156,
    contactPhone: "138****0010",
    content: [
      "三星 Galaxy S23 8+256 全网通版本。",
      "成色 9 新，屏幕无划痕，功能全部正常，可送原装保护壳。",
    ],
  },
  {
    id: 11,
    title: "二手滚筒洗衣机 9 公斤",
    summary: "9 公斤滚筒洗衣机，九成新，功能正常，静音省电，自提或同城送。",
    category: "second-hand",
    subCategory: "appliance",
    price: "599元",
    publisherName: "谢天成",
    publisherType: "personal",
    publishedAt: "2026-09-13",
    views: 2804,
    contactPhone: "138****0011",
    content: [
      "9 公斤大容量滚筒洗衣机，九成新，功能正常。",
      "运行静音省电，支持自提或同城送货。",
    ],
  },
  {
    id: 12,
    title: "回收收购电脑手机数码",
    summary: "长期高价回收手机、平板、笔记本、数码配件，好坏不限，当场结算。",
    category: "second-hand",
    subCategory: "computer",
    price: "面议",
    publisherName: "韩雪松",
    publisherType: "merchant",
    companyName: "晶丰数码科技",
    publishedAt: "2026-09-13",
    views: 478,
    contactPhone: "138****0012",
    content: [
      "长期高价回收手机、平板、笔记本及各类数码配件。",
      "好坏不限，当场验机、当场结算，支持上门回收。",
    ],
  },
  {
    id: 13,
    title: "DIY 组装机 办公家用配置",
    summary: "i5-10400/16G/512G 固态，办公家用流畅，整机保修，可自选配置。",
    category: "second-hand",
    subCategory: "computer",
    price: "2299元",
    publisherName: "唐雨桐",
    publisherType: "merchant",
    companyName: "鑫源电脑科技",
    publishedAt: "2026-09-11",
    views: 2312,
    contactPhone: "138****0013",
    content: [
      "i5-10400 / 16G 内存 / 512G 固态，办公与家用场景流畅。",
      "整机保修，支持按需求自选配置。",
    ],
  },
  {
    id: 14,
    title: "苹果笔记本 11 寸 i5 处理器",
    summary: "苹果 MacBook Air 11 寸，轻便携带，适合出差办公。",
    category: "second-hand",
    subCategory: "computer",
    price: "3500元",
    publisherName: "冯建平",
    publisherType: "personal",
    publishedAt: "2026-09-10",
    views: 5382,
    contactPhone: "138****0014",
    content: [
      "苹果 MacBook Air 11 寸，i5 处理器，机身轻便。",
      "适合出差与日常办公，续航表现良好。",
    ],
  },
  {
    id: 15,
    title: "二手 OPPO Reno 全系列",
    summary: "OPPO Reno 多款二手现货，成色好，支持验机，同城免费送货。",
    category: "second-hand",
    subCategory: "phone",
    price: "面议",
    publisherName: "曹婉婷",
    publisherType: "merchant",
    companyName: "华信通讯设备",
    publishedAt: "2026-09-10",
    views: 1445,
    contactPhone: "138****0015",
    content: [
      "OPPO Reno 全系列多款现货，成色良好。",
      "支持验机，同城免费送货，售后有保障。",
    ],
  },
  {
    id: 16,
    title: "九成新实木书桌 带书架",
    summary: "实木书桌带书架，九成新，尺寸 120×60cm，自提有优惠。",
    category: "second-hand",
    subCategory: "other",
    price: "480元",
    publisherName: "彭志远",
    publisherType: "personal",
    publishedAt: "2026-09-08",
    views: 963,
    contactPhone: "138****0016",
    content: [
      "实木书桌带书架，尺寸 120×60cm，九成新。",
      "搬家出闲置，自提可优惠。",
    ],
  },
  {
    id: 17,
    title: "房东直降 400 精装两房 拎包即住",
    summary: "精装两房，近公交站，生活配套齐全，居家首选。",
    category: "rental",
    subCategory: "whole",
    price: "3200元/月",
    publisherName: "董雅静",
    publisherType: "personal",
    publishedAt: "2026-09-10",
    views: 2021,
    recommend: true,
    contactPhone: "138****0017",
    content: [
      "精装两房，采光良好，拎包即可入住。",
      "近公交站，周边商超、菜市场等生活配套齐全。",
      "房东直租，无中介费用，租金可小幅商议。",
    ],
  },
  {
    id: 18,
    title: "办公室直租，有红本可注册，费用全包",
    summary: "精装办公室直租，80-500 平可选，包物业水电空调网络。",
    category: "rental",
    subCategory: "office",
    price: "80元/平/月",
    publisherName: "袁俊峰",
    publisherType: "merchant",
    companyName: "卓越房产管理",
    publishedAt: "2026-09-17",
    views: 7770,
    recommend: true,
    contactPhone: "138****0018",
    content: [
      "精装办公室直租，面积 80-500 平可选。",
      "产权清晰可注册公司，租金包含物业、水电、空调与网络费用。",
    ],
  },
  {
    id: 19,
    title: "日租 20 元 月租 430 元 公交站 男生合租",
    summary: "近公交站，男生合租，4 人间上下铺，包水电网。",
    category: "rental",
    subCategory: "shared",
    price: "430元/月",
    publisherName: "蒋文涛",
    publisherType: "personal",
    publishedAt: "2026-09-14",
    views: 3927,
    recommend: true,
    contactPhone: "138****0019",
    content: [
      "近公交站，出行方便，男生合租 4 人间上下铺。",
      "日租 20 元、月租 430 元，租金包含水、电、网络费用。",
    ],
  },
  {
    id: 20,
    title: "19 年江铃凯运双排平板 一手车 价格不高",
    summary: "19 年江铃凯运，五十铃发动机，车厢长 3 米 3，车况精品。",
    category: "vehicle",
    subCategory: "truck",
    price: "6.8万",
    publisherName: "邓志豪",
    publisherType: "personal",
    publishedAt: "2026-09-10",
    views: 733,
    recommend: true,
    contactPhone: "138****0020",
    content: [
      "2019 年江铃凯运双排平板，五十铃发动机。",
      "车厢长度 3.3 米，一手车，车况精品，可过户。",
    ],
  },
  {
    id: 21,
    title: "宝马 5 系 2020 款 530Li 2.0T 手自一体",
    summary: "2020 年宝马 530Li，一手车，原版原漆，无事故，包过户。",
    category: "vehicle",
    subCategory: "car",
    price: "38.8万",
    publisherName: "曾建明",
    publisherType: "merchant",
    companyName: "博雅汽车贸易",
    publishedAt: "2026-09-08",
    views: 7708,
    recommend: true,
    contactPhone: "138****0021",
    content: [
      "2020 年宝马 530Li 2.0T 手自一体，一手车。",
      "原版原漆、无事故，手续齐全，包过户。",
    ],
  },
  {
    id: 22,
    title: "24 小时电脑维修上门服务",
    summary: "系统重装、数据恢复、网络调试、硬件维修，30 分钟上门。",
    category: "service",
    subCategory: "repair",
    price: "80元起",
    publisherName: "陆海峰",
    publisherType: "merchant",
    companyName: "广源设备维修",
    publishedAt: "2026-09-15",
    views: 6253,
    recommend: true,
    contactPhone: "138****0022",
    content: [
      "提供系统重装、数据恢复、网络调试与硬件维修服务。",
      "24 小时接单，市区 30 分钟内上门，明码标价。",
    ],
  },
  {
    id: 23,
    title: "疏通管道 清理化粪池 清洗抽油烟机",
    summary: "十年工作经验，专业工具，快速上门，价格公道。",
    category: "service",
    subCategory: "cleaning",
    price: "50元起",
    publisherName: "苏晓琳",
    publisherType: "personal",
    publishedAt: "2026-09-15",
    views: 2046,
    recommend: true,
    contactPhone: "138****0023",
    content: [
      "承接管道疏通、化粪池清理与抽油烟机清洗等家政服务。",
      "十年工作经验，专业工具，快速上门，价格公道。",
    ],
  },
];
